export default "__VITE_ASSET__CBejnf9d__"